import React, { useEffect, useState } from "react";
import {
  Table,
  Card,
  InputGroup,
  Form,
  Spinner,
  Row,
  Col,
  Pagination,
  Badge,
} from "react-bootstrap";
import {
  Search,
  Building,
  Person,
  Envelope,
  Calendar,
} from "react-bootstrap-icons";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const API_BASE = "http://34.206.193.218:4001/api/admin";

const ActionSchedule = () => {
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);

  const [searchTerm, setSearchTerm] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const limit = 10;

  const token =
    localStorage.getItem("adminToken") || localStorage.getItem("token");

  /* ================= FETCH ACTION SCHEDULE ================= */
  const fetchActionSchedules = async () => {
    try {
      setLoading(true);

      const res = await axios.get(
        `${API_BASE}/actionSchedule/actionScheduleTasks`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            page: currentPage,
            limit,
            search: searchTerm || undefined,
          },
        }
      );

      if (res.data.success) {
        setTasks(res.data.data || []);
        setTotalPages(res.data.pagination?.totalPages || 1);
        setTotalRecords(res.data.pagination?.totalRecords || 0);
      } else {
        throw new Error("Failed to load data");
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to fetch action schedules");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchActionSchedules();
  }, [currentPage, searchTerm]);

  /* ================= PAGINATION ================= */
  const renderPagination = () => {
    const items = [];
    for (let i = 1; i <= totalPages; i++) {
      items.push(
        <Pagination.Item
          key={i}
          active={i === currentPage}
          onClick={() => setCurrentPage(i)}
        >
          {i}
        </Pagination.Item>
      );
    }
    return items;
  };

  return (
    <div style={{ background: "#fff", minHeight: "100vh" }}>
      <ToastContainer position="top-right" autoClose={3000} />

      {/* ===== HEADER ===== */}
      <Card className="border-0 mb-4">
        <Card.Body className="p-0">
          <Row className="align-items-center g-3">
            <Col md={6}>
              <h4 className="fw-bold mb-0">Action Schedule</h4>
              <small className="text-muted">
                Tasks requiring action and follow-ups
              </small>
            </Col>

            <Col md={6}>
              <InputGroup>
                <InputGroup.Text>
                  <Search />
                </InputGroup.Text>
                <Form.Control
                  placeholder="Search project, task, or user"
                  value={searchTerm}
                  onChange={(e) => {
                    setSearchTerm(e.target.value);
                    setCurrentPage(1);
                  }}
                />
              </InputGroup>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* ===== TABLE ===== */}
      <Card className="border-0 shadow-sm">
        <Card.Body className="p-0">
          {loading ? (
            <div className="text-center py-5">
              <Spinner />
            </div>
          ) : (
            <>
              <div className="table-responsive">
                <Table hover className="mb-0">
                  <thead className="table-dark">
                    <tr>
                      <th>Project</th>
                      <th>Task</th>
                      <th>User</th>
                      <th>Email</th>
                      <th>Estimated Time</th>
                      <th>Notes</th>
                      {/* <th>Created</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {tasks.length === 0 ? (
                      <tr>
                        <td
                          colSpan="7"
                          className="text-center py-4 text-muted"
                        >
                          No action schedules found
                        </td>
                      </tr>
                    ) : (
                      tasks.map((item) => (
                        <tr key={item._id}>
                          <td>
                            <Building className="me-1" />
                            {item.projectName}
                          </td>
                          <td>{item.taskName}</td>
                          <td>
                            <Person className="me-1" />
                            {item.userName}
                          </td>
                          <td>
                            <Envelope className="me-1" />
                            {item.userEmail}
                          </td>
                          <td>
                            <Badge bg="secondary">
                              {item.estimatedTime}
                            </Badge>
                          </td>
                          <td style={{ maxWidth: 220 }}>
                            <span className="text-muted">
                              {item.notes || "-"}
                            </span>
                          </td>
                          {/* <td>
                            <Calendar className="me-1" />
                            {new Date(item.createdAt).toLocaleDateString()}
                          </td> */}
                        </tr>
                      ))
                    )}
                  </tbody>
                </Table>
              </div>

              {/* PAGINATION */}
              {totalPages > 1 && (
                <div className="p-3 d-flex justify-content-between align-items-center">
                  <small className="text-muted">
                    Showing {(currentPage - 1) * limit + 1}–
                    {Math.min(currentPage * limit, totalRecords)} of{" "}
                    {totalRecords}
                  </small>
                  <Pagination className="mb-0">
                    {renderPagination()}
                  </Pagination>
                </div>
              )}
            </>
          )}
        </Card.Body>
      </Card>
    </div>
  );
};

export default ActionSchedule;
